// extracted by mini-css-extract-plugin
export var active = "_ks-2";
export var recordingDot = "_ks-1";
export var recordingIndicator = "_ks-0";